import React from 'react';
import { useTranslation } from 'react-i18next';

import * as userSlice from '../../data/user.slice';
import { useAppSelector } from '../../hooks/useAppSelector';
import AgreementDialog from './AgreementDialog';

interface ESADialogProps {
  open: boolean;
  close: (version: number | null) => void;
}

export default function ESADialog({ open, close }: ESADialogProps) {
  const { t } = useTranslation('common');
  const externalSupportAgreementInfo = useAppSelector(
    userSlice.selectExternalSupportAgreementInfo,
  );

  const [html, setHtml] = React.useState<string>();
  const [externalSupportAgreementVersion, setExternalSupportAgreementVersion] =
    React.useState<number | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (externalSupportAgreementInfo) {
      setExternalSupportAgreementVersion(
        externalSupportAgreementInfo?.supportAgreementID,
      );
      fetch(
        externalSupportAgreementInfo?.supportAgreementFileNameWithPath,
      ).then((resp: any) =>
        resp.text().then((html: string) => {
          setHtml(html);
          setIsLoading(false);
        }),
      );
    }
  }, [externalSupportAgreementInfo]);

  const handleAccept = () => {
    close(externalSupportAgreementVersion);
  };

  return (
    <AgreementDialog
      open={open}
      title={t('esa.title')}
      html={html}
      isLoading={isLoading}
      acceptLabel={t('esa.accept')}
      onAccept={handleAccept}
    />
  );
}
